//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('choicePossibilityList', {
//        templateUrl: 'views/components/views/choicePossibilityList/choicePossibilityList.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'utilityService', 'stateService', 'translateService', 'modalService', 'choicePossibilityListService', 'layoutService', 'ttGridFactory', function ($stateParams, utilityService, stateService, translateService, modalService, choicePossibilityListService, layoutService, ttGridFactory) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let choiceKeyno = $stateParams.choice_keyno;

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                gridReady: false,
//                mobileSize: layoutService.getMediaQueries().tablet,
//                productNameChoiceButtons: [
//                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('product', { prod_id: vm.model.setting.prod_keyno_choice }) }
//                ],
//                filterValueButtons: [
//                    { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => vm.model.setting.filtervalue = '' }
//                ],
//                bgChoicePossibilityListType: {
//                    selected: 'POSSIBLE',
//                    buttons: [
//                        { id: 'POSSIBLE', label: 'gb_choicepossibilitylist_type_possible', color: 'primary', onClick: () => setChoicePossibilityListTypeView('POSSIBLE') },
//                        { id: 'NOTPOSSIBLE', label: 'gb_choicepossibilitylist_type_notpossible', color: 'primary', onClick: () => setChoicePossibilityListTypeView('NOTPOSSIBLE') },
//                        { id: 'ALL', label: 'gb_choicepossibilitylist_type_all', color: 'primary', onClick: () => setChoicePossibilityListTypeView('ALL') }
//                    ]
//                },
//                setting: {},
//                itemsListChoicePossibilities: []
//            };

//            vm.grid = new ttGridFactory({
//                rememberId: 'w_choicepossibilitylist_grid',
//                kendo: {
//                    height: '100%',
//                    sortable: true,
//                    aggregate: true,
//                    pager: false,
//                    selectable: false,
//                    filterable: false
//                }
//            }).setToolbar({ wrapping: true });

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region BUTTON GROUP SINGLE FUNCTION

//            function setChoicePossibilityListTypeView(id) {
//                vm.model.bgChoicePossibilityListType.selected = vm.model.setting.gb_choicepossibilitylist_type = id;
//            }

//            // #endregion BUTTON GROUP SINGLE FUNCTION

//            // #region LOAD PROCEDURE CALLS

//            async function loadSetting() {
//                vm.model.setting = (await choicePossibilityListService.getSetting({ choice_keyno: choiceKeyno }))[0];
//            }

//            async function loadChoicePossibilities() {
//                if (utilityService.validateParmsValue(vm.model.setting.choice_keyno) !== true) return;
//                if (utilityService.validateParmsValue(vm.model.setting.gb_choicepossibilitylist_type) !== true) return;
                
//                vm.model.itemsListChoicePossibilities = [];
                
//                return vm.model.itemsListChoicePossibilities = await choicePossibilityListService.listChoicePossibilities(vm.model.setting);
//            }

//            // #endregion LOAD PROCEDURE CALLS

//            // #region GRID PROCEDURE FUNCTION CALLS

//            async function loadGrid() {
//                vm.grid.dataTask.loadData = {
//                    method: 3620,
//                    parameters: vm.model.setting
//                };

//                vm.model.gridReady = true;

//                if (vm.grid.gridfunc !== null) vm.grid.gridfunc.read();
//            }

//            // #endregion GRID PROCEDURE FUNCTION CALLS

//            // #region BUTTON RADIO FUNCTIONS
            
//            vm.selectBgChoicePossibilityListType = function (value) {
//                vm.model.bgChoicePossibilityListType.selected = value;
//                vm.model.setting.gb_choicepossibilitylist_type = vm.model.bgChoicePossibilityListType.selected;

//                if (vm.model.setting.gb_choicepossibilitylist_type) loadChoicePossibilities();
//            }

//            // #endregion BUTTON RADIO FUNCTIONS

//            // #region TOGGLE FUNCTIONS
            
//            vm.toggleChosen = function (item) {
//                item = item?.item ? item.item : item;
                
//                if (item.item_id === '0' || item.item_id === '-1') return;
                
//                if (item.item_is_selected === '0') {
//                    item.item_is_selected = '1';
//                } else if (item.item_is_selected === '1') {
//                    item.item_is_selected = '0';
//                }
//            }

//            // #endregion TOGGLE FUNCTIONS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;
//                let selectedItems = [];

//                vm.model.itemsListChoicePossibilities.forEach((item) => {
//                    selectedItems.push({
//                        item_id: item.item_id,
//                        item_is_selected: item.item_is_selected
//                    });
//                });

//                choicePossibilityListService.saveObj({
//                    choice_keyno: vm.model.setting.choice_keyno,
//                    records: selectedItems
//                }).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                    	modalService.show({
//                    		type: 'warning',
//                    		title: translations.error,
//                    		message: response[0].errormessage,
//                    		buttons: [{
//                    			label: translations.ok,
//                    			cssClass: 'btn-warning',
//                    			action: function (dialogItself) {
//                    				dialogItself.close();
//                    				vm.model.lockedSave = false;
//                    			}
//                    		}]
//                    	});
//                    } else {
//                    	vm.model.lockedSave = false;
//                    	stateService.back();
//                    }
//                });
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region LIFECYCLE FUNCTION

//            vm.$onInit = async function () {
//                translate();
//                await loadSetting();
//                setChoicePossibilityListTypeView(vm.model.setting.gb_choicepossibilitylist_type);
//                loadChoicePossibilities();
//                loadGrid();
//            }

//            // #endregion LIFECYCLE FUNCTION

//        }]
//    });
//})();
